// extracted by css-extract-rspack-plugin
export default {"CopyButton":"U7zTz","InfoIcon":"dSpr8"};